"use client";

import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import type { UseRequestMutationProps } from "../../../../request/hooks/useRequestMutation";
import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";
import { keyCampaignDetails } from "../../campaign/details/keyCampaignDetails";
import { keyCommunitiesGivingCampaigns } from "./keyCommunitiesGivingCampaigns";
import type { CommunitiesAdminCampaignsMutationVariables } from "./schema/communitiesAdminGivingCampaignsMutationVariablesSchema";

type UseRequestMutationsCommunitiesAdminCampaignsProps =
  UseRequestMutationProps<any, CommunitiesAdminCampaignsMutationVariables> & {
    campaignId: number;
    communityId: number;
  };

export const useRequestMutationsCommunitiesAdminCampaigns = ({
  campaignId,
  communityId,
  ...props
}: UseRequestMutationsCommunitiesAdminCampaignsProps) => {
  const locale = useLocale();
  const queryClient = useQueryClient();

  return {
    mutationPatch: useRequestMutation({
      ...props,
      mutationFnRequestProps: (data) => ({
        body: JSON.stringify(data),
        method: "PATCH",
        urlBackendPath: `/communities/${communityId}/admin/campaigns/${campaignId}`,
      }),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [keyCampaignDetails({ id: campaignId }), locale],
        });
        queryClient.invalidateQueries({
          queryKey: [
            keyCommunitiesGivingCampaigns({
              id: communityId,
            }),
            locale,
          ],
        });
      },
    }),
  };
};
